import React from 'react';
import { useTranslation } from 'react-i18next';
import './SpotifyRadio.css';

function SpotifyRadio() {
  const { t } = useTranslation();

  // Extract playlist ID from the URL
  const spotifyPlaylistUrl = "https://open.spotify.com/playlist/5fuU1YNAaMNutCWEzS7k0j?si=Ja5ox3lsTjSCTgtcBagCYQ&pi=zvyFkKo_S326D";
  const playlistId = "5fuU1YNAaMNutCWEzS7k0j";
  const embedUrl = `https://open.spotify.com/embed/playlist/${playlistId}?utm_source=generator&theme=0`;

  return (
    <section className="spotify-radio" id="radio">
      <div className="container">
        <div className="section-header animate-fade-in-up">
          <h2>{t('spotify.title')}</h2>
          <p className="section-description">
            {t('spotify.description')}
          </p>
          <div className="all-genres-badge">
            {t('spotify.allGenres')}
          </div>
        </div>

        <div className="spotify-container animate-fade-in-up">
          <div className="spotify-wrapper">
            <iframe
              src={embedUrl}
              width="100%"
              height="380"
              frameBorder="0"
              allowtransparency="true"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              title="Radio Tunco Spotify Playlist"
            ></iframe>
          </div>

          <div className="spotify-actions">
            <a
              href={spotifyPlaylistUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary spotify-btn"
            >
              {t('spotify.listenNow')}
            </a>
          </div>
        </div>

        <div className="features-grid">
          <div className="feature-card animate-fade-in-up">
            <div className="feature-icon">
              <img src="/wired-outline-1068-international-music-hover-pinch(1).png" alt="International Music" />
            </div>
            <h3>24/7 Streaming</h3>
            <p>Non-stop international radio experience</p>
          </div>
          <div className="feature-card animate-fade-in-up">
            <div className="feature-icon">
              <img src="/wired-outline-43-music-note-hover-bounce(1).png" alt="Global Music" />
            </div>
            <h3>Global Reach</h3>
            <p>Broadcasting to listeners worldwide</p>
          </div>
          <div className="feature-card animate-fade-in-up">
            <div className="feature-icon">
              <img src="/wired-outline-1031-music-album-hover-bounce.png" alt="Music Album" />
            </div>
            <h3>All Genres</h3>
            <p>Every style of music you can imagine</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SpotifyRadio;